import {useState, useEffect, useContext} from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";

import request from "../../../utilities/requests";


const GroupSize = () => {
  const { pairingEvent, setPairingEvent } = useContext(EventContext);
  const [groupSize, setGroupSize] = useState(null);
  const [menuItems, setMenuItems] = useState([4,6,8]);
  const [label, setLabel] = useState("Group Size")


  useEffect(() => {
    if (pairingEvent && pairingEvent?.pairingEventType === "dinner") {
      setLabel("Table Size");
      setMenuItems([2,4,6,8,10])
    } else {
      setLabel("Group Size");
      setMenuItems([4,6,8])
    }

    if (pairingEvent && pairingEvent?.groupSize) {
      setGroupSize(pairingEvent.groupSize);
    }
  }, [pairingEvent]);

  const handleChange = async (event) => {
    let newSize = event.target.value;
    if (newSize === groupSize) {
      return;
    }

    const body = {
      pairingEventId: pairingEvent._id,
      update: {
        groupSize: newSize,
      },
    };

    const result = await request("pairingevent/update", "post", body);
    if (!result.success) {
      alert(result.error);
      return;
    }
    setPairingEvent({...pairingEvent, groupSize: newSize})
    
  };

  return (
    <FormControl style={{ width: 100 }} size="small">
      <InputLabel id="label">{label}</InputLabel>
      <Select
        labelId="label"
        value={groupSize ? groupSize : 4}
        label="groupSize"
        onChange={handleChange}
      >
        {menuItems.map((item) => {
          return (
            <MenuItem key={`round${item}`} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default GroupSize;
